export default function useGA4Event() {
    return (eventName, eventParams) => {
        window.gtag('event', eventName, eventParams);
    };
}
